/**
 * A descriptive const to for there is  business logic for this pattern
 */
export var NO_PATTERN_BUSINESS_LOGIC = Object.seal({});
export var MOUNTED_ATTRIBUTE = 'data-mounted';
